import * as moment from "moment";

import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import {
  AutocompleteLoadingModeType,
  IAutocompleteSchema,
  IDatepickerSchema
} from "maps-angular-components";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";

import {CardType} from "../../cards/card-type";
import {Carteira} from "../../../carteira/carteira.model";
import {CarteiraService} from "../../../carteira/carteira.service";
import {EnquadradaDesenquadradaOutput} from "./EnquadradaDesenquadradaOutput";
import {Subject} from "rxjs";

@Component({
  selector: "app-enquadrada-filtro",
  templateUrl: "./enquadrada-filtro.component.html",
  styleUrls: ["./enquadrada-filtro.component.scss"],
})
export class EnquadradaFiltroComponent {
  @Input() titulo: string;
  @Input() cardType: CardType = CardType.NENHUM;
  @Output() onSearch: EventEmitter<EnquadradaDesenquadradaOutput> =
    new EventEmitter<EnquadradaDesenquadradaOutput>();

  form: FormGroup;

  @Output() searchEvent = new EventEmitter<number>();
  private pageNumber = 1;

  loading$: Subject<boolean> = new Subject<boolean>();

  public carteiraSchema: IAutocompleteSchema<Carteira>;
  public dataProcessamentoSchema: IDatepickerSchema;

  constructor(
    private formBuilder: FormBuilder,
    private carteiraService: CarteiraService
  ) {

    this.form = this.formBuilder.group({
      id: new FormControl()
    });

    this.carteiraSchema = {
      service: this.carteiraService,
      label: "Nome",
      placeholder: "Nome da carteira",
      loadingMode: AutocompleteLoadingModeType.LAZY,
      autoload: false,
      endpoint: "nome-ou-cnpj",
      formGroup: this.form,
      formControlName: "id",
      panelClass: "w-100",
      parseSearchParam(search): string {
        return search;
      },
    };

    this.dataProcessamentoSchema = {
      label: "Última data processamento",
      placeholder: "Selecione uma data",
      formGroup: this.form,
      formControlName: "dataUltimoProcessamento",
      panelClass: "w-100",
      required: true,
    };
  }

  pesquisar(value: any) {
    this.onSearch.emit(Object.assign({}, value));
    this.searchEvent.emit(this.pageNumber);
  }

  getOutputNoInput() {
    return this.getOutput(this.form.value);
  }

  getOutput(value: any) {
    let output = new EnquadradaDesenquadradaOutput();
    if (value.dataUltimoProcessamento !== null) {
      output.dataUltimoProcessamento = value.dataUltimoProcessamento
    }
    if (value.carteira !== null && value.carteira != undefined) {
      output.id = value.carteira.id;
    }
    return output;
  }

  setData(dataUltimoProcessamento: string) {
    this.form.get("dataUltimoProcessamento").setValue(dataUltimoProcessamento);
  }
}
